﻿if (!customElements.get('latest-blog-slider')) {
  customElements.define('latest-blog-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.swiper) return;
      this.viewport = this.querySelector('.latest-blog__viewport');
      this.prev = this.querySelector('.latest-blog__arrow--prev');
      this.next = this.querySelector('.latest-blog__arrow--next');
      this.abort = new AbortController();
      this.swiper = new Swiper(this.viewport, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500,
        grabCursor: true,
        simulateTouch: true,
        threshold: 6,
        preventClicks: true,
        preventClicksPropagation: true,
        watchOverflow: true,
        breakpoints: { 768: { spaceBetween: 15 } },
        navigation: { prevEl: this.prev, nextEl: this.next },
        pagination: {
          el: this.querySelector('.latest-blog__dots'),
          clickable: true,
          bulletClass: 'latest-blog__dot',
          bulletActiveClass: 'latest-blog__dot--active',
          renderBullet: (index, className) => `<button type="button" class="${className}" aria-label="Show article ${index + 1}" aria-controls="${this.viewport.id}"></button>`
        },
        on: {
          init: (swiper) => this.updateNavigation(swiper),
          slideChange: (swiper) => this.updateNavigation(swiper),
          toEdge: (swiper) => this.updateNavigation(swiper),
          fromEdge: (swiper) => this.updateNavigation(swiper),
          resize: (swiper) => this.updateNavigation(swiper),
          lock: (swiper) => this.updateNavigation(swiper),
          unlock: (swiper) => this.updateNavigation(swiper)
        }
      });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'ArrowLeft') this.swiper.slidePrev();
        else this.swiper.slideNext();
      }, { signal: this.abort.signal });
    }
    updateNavigation(swiper) {
      this.prev.disabled = swiper.isBeginning || swiper.isLocked;
      this.next.disabled = swiper.isEnd || swiper.isLocked;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.swiper?.destroy(true, true);
      this.swiper = null;
    }
  });
}
